ready(function () {

	// -- collection artist details --
	const readMoreBtn = document.querySelector('.btn__readmore');
	const readLessBtn = document.querySelector('.btn__readless');
	const readMoreContent = document.querySelector('.readmore__content');
	const mainContent = document.querySelector('.main');

	// -- Read more --
	if (readMoreBtn && readMoreContent) {
		readMoreBtn.addEventListener('click', function (e) {
				e.preventDefault();
				readMoreBtn.style.display = 'none';
				fadeIn(readMoreContent);
				scrollToElement(readMoreContent);
		});
	}

	// -- Read less --
	if (readLessBtn && mainContent && readMoreBtn && readMoreContent) {
		readLessBtn.addEventListener('click', function (e) {
				e.preventDefault();
				scrollToElement(mainContent);
				fadeIn(readMoreBtn);
				fadeOut(readMoreContent);
		});
	}

	function scrollToElement(element) {
		element.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	function fadeIn(element) {
		element.style.opacity = 0;
		element.style.display = 'block';

		let opacity = 0;
		const timer = setInterval(function () {
			if (opacity >= 1) {
				clearInterval(timer);
			}
			opacity += 0.1;
			element.style.opacity = opacity;
		}, 30);
	}

	function fadeOut(element) {
		let opacity = 1;
		const timer = setInterval(function () {
			if (opacity <= 0) {
				clearInterval(timer);
				element.style.display = 'none';
			}
			opacity -= 0.1;
			element.style.opacity = opacity;
		}, 30);
	}

});
